
import {
    Component,
    Input,
    Output,
    OnInit,
    OnChanges,
    forwardRef,
    EventEmitter,
    SimpleChange
} from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QuestionBase } from '../form/models/question-base.model';

@Component({
    selector: 'dhs-multi-dropdown',
    templateUrl: './multi-dropdown.component.html',
    styleUrls: ['./multi-dropdown.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MultiDropdownComponent),
            multi: true
        }
    ],
    standalone: false
})
export class MultiDropdownComponent implements ControlValueAccessor, OnChanges {

    @Input() options: Array<any>;
    @Input() question: any;
    @Input() placeholder: string;
    @Input('value') _value: any;
    @Input() maxSelected: number;
    @Input() showItemIndex: boolean;
    @Output() multiChange: EventEmitter<any> = new EventEmitter();
    propagateChange = (_: any) => { };
    optionsLookup = {};

    items: Array<string> = [];
    disabled: boolean = false;

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        if (changes['options']) {
            this.lookup(this.question);
        }
    }

    get value() {
        return this._value;
    }

    set value(val) {
        this.items = val;
        this.propagateChange(val);
    }

    writeValue(value) {
        if (value) {
            this.items = value;
        }else{
            this.items = [];
        }
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() { }

    onSelect(event: any) {


        let item = event.target.value;
        if (!item) return;
        let index = this.items.indexOf(item, 0);
        if (index === -1) this.items.push(item);
        event.target.value = '';
        this.value = this.items;

        if (this.maxSelected && (this.items.length === this.maxSelected)) {
            this.disabled = true;
        } else {
            this.disabled = false;
        }

        console.log("sdfsadsad", this.items);
        this.multiChange.emit(this.items);

    }

    onRemove(item: string) {
        let index = this.items.indexOf(item, 0);
        if (index > -1) this.items.splice(index, 1);
        this.value = this.items;

        if (this.maxSelected && (this.items.length < this.maxSelected)) {
            this.disabled = false;
        }

        this.multiChange.emit(this.items);
    }

    lookup(question?) {
        this.optionsLookup = this.options.reduce(function (o, el, i) {
            let getterKey = question != undefined ? question.getterKey : el.key;
            let getterValue = question != undefined ? question.getterValue : el.value;
            o[el[getterKey]] = el[getterValue];
            return o;
        }, {});
        return this.optionsLookup;
    }
    getIdKey(option, key) {
        if (option.hasOwnProperty(key.getterKey)) {
            return option[key.getterKey];
        }
    }
    getValue(option, value) {
        if (option.hasOwnProperty(value)) {
            return option[value];
        }
    }
}
